/**
 * Color utility functions
 */

/**
 * Convert hex color to rgba string
 * @param hex - Hex color code (e.g., "#FF5733")
 * @param opacity - Opacity value (0-1)
 * @returns RGBA color string (e.g., "rgba(255, 87, 51, 0.5)")
 */
export const hexToRgba = (hex: string, opacity: number): string => {
  if (!hex || typeof hex !== 'string' || !hex.startsWith('#') || hex.length < 7) {
    return `rgba(0, 0, 0, ${opacity})`;
  }
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
